import "./About.scss";

import { useTranslation } from "react-i18next";

import { LogoHorse } from "../../../assets/svg/svgIcons";
import getImageUrl from "../../../Utils/Services/img/imgFetch";

const About = () => {
  const { t } = useTranslation();

  return (
    <section className="aboutSection" id="about">
      <div className="aboutContent">
        <h1>{t("home.about.title")}</h1>
        <LogoHorse className="aboutIcon" />

        <p>{t("home.about.paragraph1")}</p>

        <p>{t("home.about.paragraph2")}</p>

        <LogoHorse className="aboutIcon" />

        <h2>{t("home.about.missionTitle")}</h2>
        {[
          t("home.about.paragraph3a"),
          t("home.about.paragraph3b"),
          t("home.about.paragraph3c"),
          t("home.about.paragraph3d"),
        ].map((para) => (
          <p key={para}>{para}</p>
        ))}
      </div>
      <img
        className="aboutImg"
        src={getImageUrl("about/4x4-vert.jpg")}
        alt="4x4 Vert"
      />
    </section>
  );
};

export default About;
